<template>
    <div id="app">
        <header>
            <router-link :to="user_name && $route.name != 'login' ? ($route.meta.package == 'navigator' ? { path: '/navigator', query: $route.query } : '/promotions') : '/'"><img src="/img/cds-logo-black.png" class="logo"></router-link>
            <div v-if="user_name && $route.name != 'login'" class="meta">
                Welcome {{ user_name }} | <router-link to="/">Logout</router-link>
                <div class="hamburger fas fa-bars" @click="showMenu = !showMenu"></div>
                <div :class="['menu', { active: showMenu }]">
                    <template v-if="$route.meta.package == 'navigator' && getUserTypeCode != 'EMPLOYEE'">
                        <router-link v-if="getUserTypeCode != 'EMPLOYEE'" :to="{ path: '/navigator', query: $route.query }">Navigator Home</router-link>
                        <div class="divider"></div>
                        <router-link :to="{ path: '/inventory', query: $route.query }">Store Inventory Report</router-link>
                        <router-link :to="{ path: '/suppliers', query: $route.query }">Inventory Received Report</router-link>
                        <router-link :to="{ path: '/sales', query: $route.query }">Store Sales Report</router-link>
                        <router-link :to="{ path: '/warehouse', query: $route.query }">Warehouse Orders Report</router-link>
                        <router-link :to="{ path: '/distributors', query: $route.query }">Distributor Movement Report</router-link>
                        <router-link v-if="getUserTypeCode.indexOf('ADMIN') > -1" :to="{ path: '/manufacturers', query: $route.query }">Manufacturer Report</router-link>
                        <div class="divider"></div>
                        <router-link to="/promotions">Promotions Home</router-link>
                    </template>
                    <template v-if="$route.meta.package == 'promotions'">
                        <router-link to="/promotions">Promotions Home</router-link>
                        <div class="divider"></div>
                        <router-link to="/promotionpacks">Promotion Packs</router-link>
                        <router-link to="/campaignreports?section">Campaign Reports</router-link>
                        <div v-if="getUserTypeCode != 'EMPLOYEE'" class="divider"></div>
                        <router-link v-if="getUserTypeCode != 'EMPLOYEE'" to="/navigator">Navigator Home</router-link>
                    </template>

                </div>
            </div>
            <div v-if="showDateAlert" style="position: absolute; top: 0.8em; left: 5em; width: 20em; font-size: 1.5em; font-weight: bold; letter-spacing: 0.05em; text-transform: uppercase; color: red;">Using data end date {{ getDebugEndDate }}</div>
        </header>

        <router-view :key="$route.fullPath"></router-view>

        <footer>
            &copy; {{ copyrightDate }} Connected Data Solutions, LLC
        </footer>

    </div>
</template>

<script>
export default {
	name: 'login',
	data() {
        return {
            user_name: '',
            user_type_code: '',
            showMenu: false,
            copyrightDate: '',
            reportYear: '',
            showDateAlert: false
        }
    },
    created() {
        this.reportYear = this.getReportYear
        let today = new Date();
        this.copyrightDate = today.getFullYear();
        this.user_name = sessionStorage.getItem('user_name')
        this.user_type_code = sessionStorage.getItem('user_type_code')
    },
    watch: {
        '$route' () {
            this.showMenu = false
            this.user_name = sessionStorage.getItem('user_name')
        },
        'getReportYear' () {
            this.reportYear = this.getReportYear
        },
        'getDebugEndDate' () {
            this.showDateAlert = this.getDebugEndDate
        }
    },
    computed: {
        showYearSelect() {
            return ['inventory','inventory-department','sales','sales-department','suppliers','suppliers-supplier','warehouse','warehouse-distributor','distributors','distributors-distributor'].includes(this.$route.name)
        },
        getUserTypeCode() {
            if (this.getUser && this.getUser.user_type_code) {
                return this.getUser.user_type_code
            } else {
                return ''
            }
        }
    },
    methods: {
        setReportYear() {
            this.showMenu = false
            this.updateReportYear(this.reportYear)
        }
    }
}
</script>

<style lang="scss">
</style>
